import { useDateFormatter } from '@mint-lib/formatting-hooks';
import { parseISO } from 'date-fns';

const LevelDateRange = ({
  dateFrom,
  dateTo,
}: {
  dateFrom: string;
  dateTo: string;
}) => {
  const formatter = useDateFormatter(parseISO(dateFrom), parseISO(dateTo));

  return formatter.formattedDateRange;
};

export default LevelDateRange;
